import * as lib from '~/dependencies';
import { colors } from '~/layout';

const { keyframes, css } = lib.StyledComponents;

type ContainerProps = {
  hasError: string;
};

type WarnMessageProps = {
  borderBottom: boolean;
};

type InputProps = {
  /**
   * WhatsApp Templates are read-only.
   * In some cases, you can edit only the parameters.
   * On the other hand, 10DLC allows free editing of the template.
   */
  isSpecialTemplate: boolean;
};

type ButtonProps = {
  highlight?: boolean;
  active?: boolean;
};

const templatePulseAnimation = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(87, 181, 81, 0.6);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(87, 181, 81, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(87, 181, 81, 0);
  }
`;

export const Container = lib.styled.div<ContainerProps>`
    display: flex;
    flex-direction: column;
    align-items: center;
width: calc(100% - 20px);
    border: 1px solid ${(props: ContainerProps) =>
      props.hasError ? colors.red : colors.lightGray};
    border-radius: 8px;
    margin: 10px;
    box-shadow: 0px 0px 20px 0px #0000001A;
`;

export const Row = lib.styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    width: calc(100% - 20px);
    max-width: calc(100% - 20px);
    gap: 10px;

    margin: 10px;
    box-sizing: border-box;

    .input-wrapper {
        display: flex;
        flex: 1;
        min-width: 0;
    }
    
    .highlight {
        padding: 2px 4px;
        background-color: #5bb5ef;
        font-weight: bold;
        border-radius: 8px;
        color: ${colors.white};
        font-size: 14px;
        cursor: text;
        transition: all 0.2s ease;
    }

    .highlight:hover {
        background: #3da0dc; /* darker blue */
        transform: scale(1.05);
        box-shadow: 0 0 20px rgba(0,255,255,0.5);
    }
`;

export const Actions = lib.styled.div`
    display: flex;
    gap: 8px;
    flex-shrink: 0;
`;

export const Input = lib.styled.div<InputProps>`
    font-size: 16px;
    font-family: Nunito;
    line-height: 1.4;
    border: none;
    outline: none;
    /* direction: rtl; */
    text-align: left;
    unicode-bidi: plaintext;
    overflow-y: auto;  
    // padding-left: 10px;
    color: ${colors.darkGray13};
    letter-spacing: 0.5px;
    overflow-wrap: anywhere;
    /* width: 100%; */
    min-width: 0;


    ${({ isSpecialTemplate }: InputProps) =>
      isSpecialTemplate &&
      `
        background-color: #ECF9FD;
        border-radius: 10px;
        padding: 10px;
    `}


    max-height: 112.5px;
    transition: max-height 0.5s ease;

    &[data-placeholder]:empty::before {
        content: attr(data-placeholder);
        color: ${colors.darkGray13};
        font-size: var(--placeholder-font-size, 16px);
        font-style: italic;
        opacity: 0.5;
        pointer-events: none;
    }

    ::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }

    ::-webkit-scrollbar-track {
        background: ${colors.lightGray18};
        border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb {
        background: ${colors.lightBlue15};
        border-radius: 10px;
    }
`;

export const WarnMessage = lib.styled.div<WarnMessageProps>`
    display: flex;
    flex-direction: column;
    background: ${colors.red08}; 
    border-top-left-radius: 9px;
    border-top-right-radius: 9px;
    border-bottom: 1px solid ${(props: WarnMessageProps) =>
      props.borderBottom ? colors.red : 'none'};
    width: 100%;
    color: ${colors.red11};

    span {
        margin: 7px;
        font-size: 13px;
        text-align: center;
    }
`;

export const Bold = lib.styled.b``;

export const Button = lib.styled(lib.ReactSVG)<ButtonProps>`
    cursor: pointer;
    border-radius: 22%;

    svg {
        display: block;
    }

    ${({ active }: ButtonProps) =>
      active &&
      css`
        svg path {
          fill: #5bb5ef;
          stroke: #5bb5ef;
        }
      `}

    ${({ highlight }: ButtonProps) =>
      highlight &&
      css`
        animation: ${templatePulseAnimation} 1.6s ease-in-out infinite;
      `}
`;

export const TemplateBanner = lib.styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 8px 12px;
    background: ${colors.lightGray18};
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom: 1px solid ${colors.lightGray};
    color: ${colors.darkGray13};
    font-size: 13px;
    box-sizing: border-box;
`;

export const TemplateBannerLabel = lib.styled.span`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-right: 10px;

    b {
        font-weight: 700;
    }
`;

export const ClearTemplateButton = lib.styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    padding: 2px;
    cursor: pointer;
    color: ${colors.darkGray11};
    border-radius: 4px;

    &:hover {
        background: ${colors.lightGray};
    }

    svg {
        width: 18px;
        height: 18px;
    }
`;
